import { required, requiredIf } from 'vuelidate/lib/validators';
import moment from 'moment';


const validation = {
  quantity: {
    min(val) {
      if (val !== '' && (this.addingFpDrug || this.type === 'TPN')) {
        if (parseInt(val, 0) < parseInt(this.minQuantity, 0)) {
          return false;
        }
      }

      return true;
    },
    // max(val) {
    //   if (val !== '' && this.addingFpDrug) {
    //     if (this.qtyMultiple === 1 && parseInt(val, 0) > this.maxQuantity) {
    //       return false;
    //     }
    //   }
    //
    //   return true;
    // },
    qtyMultiple(val) {
      if (val !== '' && (this.addingFpDrug || this.type === 'TPN')) {
        if (this.qtyMultiple) {
          if ((parseInt(val, 0) % this.qtyMultiple) !== 0) {
            return false;
          }
        }
      }
      return true;
    },
    gtzero(val) {
      if (val !== '') {
        if (parseFloat(val) <= 0) {
          return false;
        }
      }
      return true;
    },
  },
  drug1_name: {
    required,
  },
  drug1_dose: {
    gtzero(val) {
      if (val !== '') {
        if (parseFloat(val) <= 0) {
          return false;
        }
      }
      return true;
    },
    required: requiredIf(function () {
      if (this.isTPN()) {
        return false;
      }
      if (!this.addingFpDrug) {
        return true;
      }
      return false;
    }),
    max(val) {
      if (this.isTPN()) {
        return true;
      }
      return val;
      // if (val !== '' && parseFloat(val) > parseFloat(this.drug1_maxdose)) {
      //   return false;
      // }
      //
      // return true;
    },
    maxDecimal(val) {
      if (val && val !== '') {
        const m = val.toString().split('.');
        if (m.length === 1) {
          return true;
        }
        if (m && typeof m[1] !== 'undefined' && (m.length > 1)) {
          if (m[1].toString().length > 2) {
            return false;
          }
        }
      }
      return true;
    },
  },
  drug2_id: {
    required: requiredIf(function () {
      if (this.addingFpDrug) {
        return false;
      }

      if (this.displaySecondDrug) {
        return true;
      }

      return false;
    }),
  },
  drug2_dose: {
    gtzero(val) {
      if (val !== '') {
        if (parseFloat(val) <= 0) {
          return false;
        }
      }
      return true;
    },
    required: requiredIf(function () {
      if (this.addingFpDrug) {
        return false;
      }

      if (this.displaySecondDrug) {
        return true;
      }

      return false;
    }),
    maxDecimal(val) {
      if (val && val !== '') {
        const m = val.toString().split('.');
        if (m.length === 1) {
          return true;
        }
        if (m && typeof m[1] !== 'undefined') {
          if (m[1].toString().length > 2) {
            return false;
          }
        }
      }
      return true;
    },
  },
  adminRouteCode: {
    required: requiredIf(function () {
      if (this.addingFpDrug) {
        return false;
      }
      if (this.type === 'TPN') {
        return false;
      }

      return true;
    }),
  },
  containerTypeId: {
    required: requiredIf(function () {
      if (this.addingFpDrug) {
        return false;
      }
      if (this.type === 'TPN') {
        return false;
      }

      return true;
    }),
  },
  diluent_id: {
    required: requiredIf(function () {
      if (this.addingFpDrug) {
        return false;
      }
      if (this.isDiluentOptional) {
        return false;
      }
      if (this.type === 'TPN') {
        return false;
      }
      return true;
    }),
  },
  infusionTime: {
    required: requiredIf(function () {
      if (this.addingFpDrug) {
        return false;
      }
      if (this.type === 'TPN') {
        return false;
      }
      if (this.hasInfusionTime === false) {
        return false;
      }

      return true;
    }),
    minValue(val) {
      if (val === '') {
        return true;
      }

      if (parseFloat(val, 0) <= 0) {
        return false;
      }

      return true;
    },
    maxValue(val) {
      if (val === '') {
        return true;
      }

      if (parseFloat(val, 0) > (168 * 60)) {
        return false;
      }

      return true;
    },
    maxDecimal(val) {
      if (val && (val !== '') && (val !== '0') && (val !== 0)) {
        const m = val.toString().split('.');
        if (m.length === 1) {
          return true;
        }
        if (m && typeof m[1] !== 'undefined') {
          if (m[1].toString().length > 2) {
            return false;
          }
        }
      }
      return true;
    },
  },
  containerId: {
    required: requiredIf(function () {
      if (this.addingFpDrug) {
        return false;
      }

      if (this.type === 'TPN') {
        return false;
      }

      return true;
    }),
  },
  diluentVolume: {
    required: requiredIf(function () {
      if (this.addingFpDrug) {
        return false;
      }
      if (this.type === 'TPN') {
        return false;
      }
      if (this.isExactVolumeOptional === true) {
        return false;
      }

      return true;
    }),
    minValue(val, vm) {
      if (val === '' || vm.minDiluentVolume === '') {
        return true;
      }

      if (vm.diluentExactFinalVolume === true) {
        if (parseFloat(val) < parseFloat(vm.minDiluentVolume)) {
          return false;
        }

        return true;
      }

      return true;
    },
    gtzero(val, vm) {
      if (vm.diluentExactFinalVolume === true) {
        if (val !== '') {
          if (parseFloat(val) <= 0) {
            return false;
          }
        }
      }
      return true;
    },
    maxValue(val, vm) {
      if (val === '' || vm.maxDiluentVolume === '') {
        return true;
      }

      if (vm.diluentExactFinalVolume === true) {
        if (parseFloat(val) > parseFloat(vm.maxDiluentVolume)) {
          return false;
        }

        return true;
      }

      return true;
    },
    maxDecimal(val) {
      if (val && val !== '') {
        const m = val.toString().split('.');
        if (m.length === 1) {
          return true;
        }
        if (m && typeof m[1] !== 'undefined') {
          if (m[1].toString().length > 2) {
            return false;
          }
        }
      }
      return true;
    },
  },
  ancillary1Id: {
    required: requiredIf(function () {
      if (this.addingFpDrug) {
        return false;
      }
      if (this.type === 'TPN') {
        return false;
      }

      if (this.defaultAncillaryValue !== '') {
        return true;
      }

      return false;
    }),
  },
  treatmentDate: {
    validDate(val) {
      if (val === '') {
        return true;
      }

      return moment(val, ['DD/MM/YYYY', 'D/M/YYYY'], true).isValid();
    },
    pastDate(val) {
      if (val === '') {
        return true;
      }

      if (moment(val, ['DD/MM/YYYY', 'D/M/YYYY'], true).isValid() === false) {
        return true;
      }

      const today = moment().format('DD/MM/YYYY');

      const now = moment(today, 'DD/MM/YYYY');
      const date = moment(val, 'DD/MM/YYYY');

      if (date.diff(now, 'days') < 0) {
        return false;
      }

      return true;
    },
  },
  deliveryDateArray: {
    $each: {
      checkDateSet(dateSet) {
        if (dateSet[0] === false) {
          return false;
        }
        if (dateSet[0] === '') {
          return false;
        }
        if (moment(dateSet[0], ['DD/MM/YYYY', 'D/M/YYYY'], true).isValid() === false) {
          return false;
        }

        const today = moment().format('DD/MM/YYYY');

        const now = moment(today, 'DD/MM/YYYY');
        let date = moment(dateSet[0], 'DD/MM/YYYY');

        if ((dateSet[0] !== '' && dateSet[0] !== false) && (dateSet[1] !== '' && dateSet[1] !== false)) {
          const date1 = moment(dateSet[1], 'DD/MM/YYYY');
          if (date1.diff(date, 'days') < 0) {
            return false;
          }
        }

        if (date.diff(now, 'days') < 0) {
          return false;
        }

        if (dateSet[1] !== false) {
          if (moment(dateSet[1], ['DD/MM/YYYY', 'D/M/YYYY'], true).isValid() === false) {
            return false;
          }

          date = moment(dateSet[1], 'DD/MM/YYYY');

          if (date.diff(now, 'days') < 0) {
            return false;
          }
        }

        if (dateSet[2] === false) {
          return false;
        }
        if (dateSet[2] === '') {
          return false;
        }

        if (dateSet[2] <= 0) {
          return false;
        }
        if (dateSet[2] !== '' && (this.addingFpDrug || this.type === 'TPN')) {
          if (parseInt(dateSet[2], 0) < parseInt(this.minQuantity, 0)) {
            return false;
          }
        }
        if (dateSet[2] !== '' && (this.addingFpDrug || this.type === 'TPN')) {
          if (parseInt(dateSet[2], 0) < parseInt(this.minQuantity, 0)) {
            return false;
          }
        }
        if (dateSet[2] !== '' && (this.addingFpDrug || this.type === 'TPN')) {
          if (this.qtyMultiple && ((dateSet[2] % this.qtyMultiple) !== 0)) {
            return false;
          }
        }

        return true;
      },
    },
  },
};

export default validation;
